// 动态创建路由
export let createRoutes = function (children, data) {
  // 把 Summary 去掉注释，即可不登录也能进入到页面
  // children.push({
  //   path: '/Summary',
  //   name: 'Summary',
  //   component: () => import('@/views/Summary/Summary.vue'),
  // })
  // children.push({ path: '/HomePagePDF', name: '/HomePagePDF', component: () => import('@/components/Form/BaseForm') })
  children.push({
    path: '/HomeRedirect',
    name: '/HomeRedirect',
    component: () => import('../views/home/HomeRedirect.vue'),
  })
  data.forEach((item) => {
    generateRoutes(children, item)
  })
  sessionStorage.setItem('routerchildren', JSON.stringify(children))
}

function generateRoutes(children, item) {
  if (
    item.path != null &&
    item.path !== '' &&
    (!item.children || item.children.length === 0)
  ) {
    let path = item.md5Path
    let option = children.filter((item) => {
      return item.name === '/' + path
    })
    if (option.length === 0) {
      children.push({
        path: '/' + path,
        name: '/' + path,
        component: getComponents(item.name),
      })
    }
  } else if (item.children) {
    item.children.forEach((e) => {
      generateRoutes(children, e)
    })
  }
}

import Employee from '@/views/Employee/Employee.vue'
import BMenuGroup from '@/views/Common/BMenuGroup/BMenuGroup.vue'
import Settings from '@/views/Settings/Settings.vue'
import RequirementsGather from '@/views/RequirementsGather/RequirementsGather.vue'
import DataProcessing from '@/views/DataProcessing/DataProcessing.vue'
import HomePage from '@/views/home/HomePage.vue'

function getComponents(menuName) {
  switch (menuName) {
    case '系统日志':
      return HomePage
    case '基础设置':
      return Settings
    case '人员档案':
      return Employee
    case '模块菜单':
      return BMenuGroup
    case '需求登记':
      return RequirementsGather
    case '数据处理':
      return DataProcessing
  }
}
